import React, {  } from 'react';
import { Widget, usePromise, Table } from '@digital/ui';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  HistoricoMedicao,
  HistoricoRateio,
  getAllHistoricoMedicaoById,
  getAllHistoricoMedicaoLogNdaById,
  getAllHistoricoRateioById,
  getAllHistoricoSlaById,
  HistoricoSla,
} from '@app/api/historicoMedicao';
import { useRecoilState, useRecoilValue } from 'recoil';
import { medicaoSelectedState } from '../atoms';

const columns = [
  {
    title: 'Responsável',
    dataIndex: 'usuarioResponsavel',
    key: 'usuarioResponsavel',
    width: '15%',
  },
  {
    title: 'Descrição',
    dataIndex: 'descricao',
    key: 'descricao',
    width: '30%',
  },
  {
    title: 'Data / Hora',
    dataIndex: 'dataHoraFormatada',
    key: 'dataHoraFormatada',
    width: '15%',
  },
  {
    title: 'Status Anterior',
    dataIndex: 'statusAnterior',
    key: 'statusAnterior',
    width: '20%',
  },
  {
    title: 'Novo Status',
    dataIndex: 'novoStatus',
    key: 'novoStatus',
    width: '20%',
  },
];

const AbaHistorico = () => {
  const medicaoSelected = useRecoilValue(medicaoSelectedState);

  const [data] = usePromise(
    () => (medicaoSelected ? getAllHistoricoMedicaoById(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected],
    [] as HistoricoMedicao[],
  );

  const [dataLogNda] = usePromise(
    () => (medicaoSelected ? getAllHistoricoMedicaoLogNdaById(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected],
    [] as HistoricoMedicao[],
  );

  const [dataRateio] = usePromise(
    () => (medicaoSelected ? getAllHistoricoRateioById(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected],
    [] as HistoricoRateio[],
  );

  const [dataSla] = usePromise(
    () => (medicaoSelected ? getAllHistoricoSlaById(medicaoSelected.id) : Promise.resolve(undefined)),
    [medicaoSelected],
    [] as HistoricoSla[],
  );

  return (
    <>
      <Widget title="Aprovação Técnica">
        <PerfectScrollbar>
          <Table columns={columns} rowKey="index" dataSource={data} pagination={false} />
        </PerfectScrollbar>
      </Widget>

      <Widget title="SLA">
        <PerfectScrollbar>
          <Table columns={columns} dataSource={dataSla} pagination={false} />
        </PerfectScrollbar>
      </Widget>

      <Widget title="Aprovação por níveis de Competência - Norma de Aprovação e Delegação de Autoridade">
        <PerfectScrollbar>
          <Table columns={columns} dataSource={dataLogNda} pagination={false} />
        </PerfectScrollbar>
      </Widget>

      <Widget title="Rateio">
        <PerfectScrollbar>
          <Table columns={columns} dataSource={dataRateio} pagination={false} />
        </PerfectScrollbar>
      </Widget>
    </>
  );
};

export default AbaHistorico;
